export const priceValues = [
  { key: '0', display: '£0' },
  { key: '1000', display: '£1,000' },
  { key: '2000', display: '£2,000' },
  { key: '3000', display: '£3,000' },
  { key: '4000', display: '£4,000' },
  { key: '5000', display: '£5,000' },
  { key: '6000', display: '£6,000' },
  { key: '7000', display: '£7,000' },
  { key: '8000', display: '£8,000' },
  { key: '9000', display: '£9,000' },
  { key: '10000', display: '£10,000' },
  { key: '11000', display: '£11,000' },
  { key: '12000', display: '£12,000' },
  { key: '13000', display: '£13,000' },
  { key: '14000', display: '£14,000' },
  { key: '15000', display: '£15,000' },
  { key: '16000', display: '£16,000' },
  { key: '18000', display: '£18,000' },
  { key: '20000', display: '£20,000' },
  { key: '25000', display: '£25,000' },
  { key: '30000', display: '£30,000' },
  { key: '40000', display: '£40,000' },
  { key: '50000', display: '£50,000' },
  { key: '75000', display: '£75,000' },
  { key: '100000', display: '£100,000' },
  { key: '250000', display: '£250,000' },
  { key: '500000', display: '£500,000' },
  { key: '1000000', display: '£1,000,000' },
  { key: '2000000', display: '£2,000,000' },
  { key: '3000000', display: '£3,000,000' }
];

export const priceValuesLeasing = [
  { key: '0', display: '£0' },
  { key: '150', display: '£150' },
  { key: '200', display: '£200' },
  { key: '250', display: '£250' },
  { key: '300', display: '£300' },
  { key: '350', display: '£350' },
  { key: '400', display: '£400' },
  { key: '450', display: '£450' },
  { key: '500', display: '£500' },
  { key: '600', display: '£600' },
  { key: '700', display: '£700' },
  { key: '800', display: '£800' },
  { key: '900', display: '£900' },
  { key: '1000', display: '£1,000' },
  { key: '2000', display: '£2,000' },
  { key: '3000', display: '£3,000' }
];

export const withinDistanceValues = [
  { key: 10, display: '10 miles' },
  { key: 20, display: '20 miles' },
  { key: 30, display: '30 miles' },
  { key: 40, display: '40 miles' },
  { key: 60, display: '60 miles' },
  { key: 80, display: '80 miles' },
  { key: 100, display: '100 miles' },
  { key: 150, display: '150 miles' },
  { key: 200, display: '200 miles' },
  { key: null, display: 'Over 200 miles' }
];

export const topEightCarTypes = [
  { key: 'Hatchback' },
  { key: 'SUV' },
  { key: 'Saloon' },
  { key: 'Coupe' },
  { key: 'Estate' },
  { key: 'MPV' },
  { key: 'Convertible' }
];

export const availableCarTypesList = topEightCarTypes.map(item => item.key);

export const sortByValues = [
  { key: '', sortBy: '', sort: '', display: 'Relevance' },
  { key: 'asc', sortBy: 'price', sort: 'Asc', display: 'Price (lowest)' },
  {
    key: 'desc',
    sortBy: 'price',
    sort: 'Desc',
    display: 'Price (highest)'
  },
  {
    key: 'leaseAsc',
    sortBy: 'leaseMonthly',
    sort: 'PriceAsc',
    display: 'Price (lowest)'
  },
  {
    key: 'leaseDesc',
    sortBy: 'leaseMonthly',
    sort: 'PriceDesc',
    display: 'Price (highest)'
  },
  { key: 'distance', sortBy: 'distance', sort: '', display: 'Distance' },
  {
    key: 'odometerReadingMiles',
    sortBy: 'odometerReadingMiles',
    sort: 'Asc',
    display: 'Mileage'
  },
  { key: 'newest', sortBy: 'vehicleAge', sort: 'Desc', display: 'Age (newest)' }
];



// WEBPACK FOOTER //
// ./src/Common/filterValues/index.js